import { render, staticRenderFns } from "./global-loader.vue?vue&type=template&id=77028848&scoped=true&"
import script from "./global-loader.vue?vue&type=script&lang=js&"
export * from "./global-loader.vue?vue&type=script&lang=js&"
import style0 from "./global-loader.vue?vue&type=style&index=0&id=77028848&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77028848",
  null
  
)

export default component.exports